import { render, staticRenderFns } from "./campus-details.vue?vue&type=template&id=2ebca474&scoped=true"
import script from "./campus-details.vue?vue&type=script&lang=js"
export * from "./campus-details.vue?vue&type=script&lang=js"
import style0 from "./campus-details.vue?vue&type=style&index=0&id=2ebca474&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebca474",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ebca474')) {
      api.createRecord('2ebca474', component.options)
    } else {
      api.reload('2ebca474', component.options)
    }
    module.hot.accept("./campus-details.vue?vue&type=template&id=2ebca474&scoped=true", function () {
      api.rerender('2ebca474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dollars/campus-details.vue"
export default component.exports